import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { lclWeightUnit } from "../../../rate/lcl-weight-unit.const";
import { SelectItem } from "primeng/api";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-weight-unit-select",
  templateUrl: "./weight-unit-select.component.html",
  styleUrls: ["./weight-unit-select.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class WeightUnitSelectComponent implements OnChanges {
  @Input() public weightUnit = lclWeightUnit.kg;
  @Input() public label = "Weight unit";
  public readonly weightUnitChange = output<string>();

  public options: SelectItem[] = [lclWeightUnit.kg, lclWeightUnit.t].map(
    (unit) => ({ label: unit, value: unit }),
  );

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.weightUnit) {
      this.weightUnit = changes.weightUnit.currentValue;
    }
  }

  public onChange(event) {
    this.weightUnitChange.emit(this.weightUnit);
  }
}
